import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Yugi from '../pages/Yugi';
import Layout from './Layout';



function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/yugioh-new-player" element={<Yugi />} exact />
          </Routes>
        </Layout>
      </BrowserRouter>
    </React.Fragment>

  );
}



export default App;